import script from "./crear.vue?vue&type=script&setup=true&lang=js"
export * from "./crear.vue?vue&type=script&setup=true&lang=js"

import "./crear.vue?vue&type=style&index=0&id=2f4311ee&lang=css"

const __exports__ = script;

export default __exports__